import {
  COMPARATOR_CHANGE
} from '../constants/ActionTypes';


export const onComparatorChange = (value) => {
  return {
    type: COMPARATOR_CHANGE,
    payload:value
  };
};
